import { Directive, ElementRef, HostListener, Input } from '@angular/core';

interface IInputPattern {
    pattern: string;
    regexp: RegExp;
    name: string;
}
class InputPattern implements IInputPattern {
    pattern: string;
    regexp: RegExp;
    name: string;
    constructor(name: string, pattern: string) {
        this.name = name;
        this.pattern = pattern;
        this.regexp = new RegExp(pattern);
    }
}
@Directive({
    selector: '[respectLength]'
})
export class RespectLengthDirective {
    /**properties*/
    @Input() patternToRespect: string;
    /** */

    /** ##### PATTERNS ##### */
    /** Ricordarsi {0, MAX}*/
    usernamePattern = new InputPattern('username', '^.{0,19}$');
    emailPattern = new InputPattern('email', '^.{0,30}$');
    searchBarPattern = new InputPattern('searchbar', '^.{0,80}$');
    sigprovincePattern = new InputPattern('sigprov', '^.{0,2}$');
    postalCodePattern = new InputPattern('postalcode', '^.{0,5}$');
    pivaPattern = new InputPattern('piva', '^.{0,11}$');
    fiscalCodePattern = new InputPattern('fiscalcode', '^.{0,16}$');
    fiscalCodeOrPivaPattern = new InputPattern('fiscalCodeOrPiva', '^.{0,16}$');
    phonePattern = new InputPattern('phone', '^.{0,20}$');
    podPattern = new InputPattern(
        'pod',
        '^.{0,14}$'
        //il lookbehind non è supportato da tutti i browswe
    );
    pdrPattern = new InputPattern('pdr', '^.{0,14}$');
    ibanPattern = new InputPattern('iban', '^.{0,30}$');
    maxLength100 = new InputPattern('maxLength100', '^.{0,100}$');
    remiPattern = new InputPattern('remi', '^.{0,20}$');
    /** ##### end patterns ##### */

    //constructor
    constructor(private element: ElementRef<HTMLInputElement>) {}

    //Ctrl combinations
    static allowCtrlCombination(event: KeyboardEvent, chr: 'A'|'C'|'V'|'X'): boolean {
        return event.ctrlKey && event.key === chr;
    }
    static allowCtrlA(event: KeyboardEvent): boolean {
        return RespectLengthDirective.allowCtrlCombination(event, 'A');
    }
    static allowCtrlC(event: KeyboardEvent): boolean {
        return RespectLengthDirective.allowCtrlCombination(event, 'C');
    }
    static allowCtrlV(event: KeyboardEvent): boolean {
        return RespectLengthDirective.allowCtrlCombination(event, 'V');
    }
    static allowCtrlX(event: KeyboardEvent): boolean {
        return RespectLengthDirective.allowCtrlCombination(event, 'X');
    }
    static allowTab(event: KeyboardEvent) {
        return event.key === 'Tab' || event.key === 'TAB';
    }
    static allowCommonCtrlCombinations(event: KeyboardEvent) {
        return (
            RespectLengthDirective.allowCtrlA(event) ||
            RespectLengthDirective.allowCtrlC(event) ||
            RespectLengthDirective.allowCtrlX(event) ||
            RespectLengthDirective.allowCtrlV(event)
        );
    }

    static blockExceptSelectedPattern(event: KeyboardEvent, pattern: IInputPattern) {
        //allow tab and ctrl combinations
        if (
            RespectLengthDirective.allowTab(event) ||
            RespectLengthDirective.allowCommonCtrlCombinations(event)
        ) {
            return;
        }
        console.log(`RESPECT PATTERN ${pattern.name}=${pattern.pattern}`);
        //regexp check
        const value = (<HTMLInputElement>event.target).value;
        const newValue = value + event.key;
        const testPassed = pattern.regexp.test(newValue);
        /*console.log(`
      inputValue ='${value}'(length=${value.length})\n
      new inputValue='${newValue}'(length= ${newValue.length})\n
      regexp='${pattern.regexp}'\n
      testPassed='${testPassed}'.`);*/
        if (!testPassed) {
            // console.log("prevent default"); //dbg
            console.log('TEST NOT PASSED');
            event.preventDefault();
        }
        return;
    }

    //host listener keypress
    @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent) {
        switch (this.patternToRespect) {
            //username pattern
            case this.usernamePattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(
                    event,
                    this.usernamePattern
                );
            //searchbar pattern
            case this.searchBarPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(
                    event,
                    this.searchBarPattern
                );
            case this.emailPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.emailPattern);
            case this.sigprovincePattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(
                    event,
                    this.sigprovincePattern
                );
            case this.postalCodePattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(
                    event,
                    this.postalCodePattern
                );
            case this.pivaPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.pivaPattern);
            case this.fiscalCodePattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(
                    event,
                    this.fiscalCodePattern
                );
            case this.fiscalCodeOrPivaPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.fiscalCodeOrPivaPattern);
            case this.phonePattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.phonePattern);
            case this.podPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.podPattern);
            case this.pdrPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.pdrPattern);
            case this.ibanPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.ibanPattern);
            case this.maxLength100.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.maxLength100);
            case this.remiPattern.name:
                return RespectLengthDirective.blockExceptSelectedPattern(event, this.remiPattern);
            default:
                console.error(`UNRECOGNIZED PATTERN TO RESPECT '${this.patternToRespect}'`);
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/respectLength.directive.ts